import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from '@chakra-ui/react';

interface SideModalProps {
  titulo: string;
  isOpen: boolean;
  onClose: () => void;
}
export const SideModal: React.FC<SideModalProps> = ({
  children,
  titulo,
  isOpen,
  onClose,
}) => {
  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
      <DrawerOverlay />
      <DrawerContent borderTopLeftRadius="md">
        <DrawerCloseButton />
        <DrawerHeader>{titulo}</DrawerHeader>
        <DrawerBody>{children}</DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
